// Copyright (c) 2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';

// import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { SvgIcon, SvgIconProps } from '@mui/material';

type Props = SvgIconProps

export const Map: React.FC<Props> = (props) => {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <g opacity="0.34">
        <path 
            d="M 12.351562 3.804688 L 12.351562 0.855469 L 0 0.855469 L 0 12.75 L 9.671875 12.75 C 10.449219 13.78125 11.132812 14.542969 11.167969 14.578125 L 11.675781 15.144531 L 12.1875 14.578125 C 12.226562 14.535156 13.132812 13.527344 14.050781 12.25 C 15.363281 10.433594 16 9.070312 16 8.074219 C 16 5.921875 14.417969 4.128906 12.351562 3.804688 Z M 3.660156 11.378906 L 1.371094 11.378906 L 1.371094 2.226562 L 3.660156 2.226562 Z M 7.320312 11.378906 L 5.03125 11.378906 L 5.03125 2.226562 L 7.320312 2.226562 Z M 10.980469 2.226562 L 10.980469 3.808594 C 10.101562 3.953125 9.308594 4.359375 8.691406 4.949219 L 8.691406 2.226562 Z M 8.691406 11.363281 C 8.695312 11.371094 8.699219 11.375 8.699219 11.378906 L 8.691406 11.378906 Z M 11.675781 13.074219 C 10.371094 11.519531 8.726562 9.195312 8.726562 8.074219 C 8.726562 6.449219 10.050781 5.125 11.675781 5.125 C 13.304688 5.125 14.628906 6.449219 14.628906 8.074219 C 14.628906 9.191406 12.984375 11.519531 11.675781 13.074219 Z M 11.675781 13.074219"
        />
        <path 
            d="M 12.746094 8.039062 C 12.746094 8.628906 12.269531 9.109375 11.675781 9.109375 C 11.085938 9.109375 10.605469 8.628906 10.605469 8.039062 C 10.605469 7.445312 11.085938 6.964844 11.675781 6.964844 C 12.269531 6.964844 12.746094 7.445312 12.746094 8.039062 Z M 12.746094 8.039062"
        />
      </g>
    </SvgIcon>
  );
};